import React, { Component, PropTypes } from "react";
import InputMask from "react-input-mask";
import { ControlLabel, FormControl, FormGroup, HelpBlock } from "react-bootstrap";
import classNames from "classnames";
import { FormattedMessage } from "react-intl";

class MaskedInput extends Component {
    constructor(props, context) {
        super(props, context);

        this.generateControl = this.generateControl.bind(this);
    }
    generateControl(inputProps) {
        const { className, input, rest, onPaste, disabled } = this.props;
        // eslint-disable-next-line no-unused-vars
        const { onBlur, ...formControlInput } = input;

        return (
            <FormControl
                onPaste={onPaste}
                {...inputProps}
                {...rest}
                {...formControlInput}
                type="text"
                disabled={disabled}
                className={className}
            />
        );
    }
    render() {
        const {
            input,
            mask,
            groupClassName,
            placeholder,
            label,
            required,
            formatOverlay,
            showFieldValidationError,
            onPaste,
            onBlur,
            forcedValidationErrorKey,
            id,
            disabled,
            meta: { touched, error, warning },
        } = this.props;

        let validationState = !!error ? error.state || "error" : null;
        let validationMessageKey = !!error && error.messageKey ? error.messageKey : forcedValidationErrorKey;
        let validationValues = !!error && error.values ? error.values : {};

        if (forcedValidationErrorKey && showFieldValidationError) validationState = "error";

        if (touched && !!warning) {
            /**
             * Allows us to display error on field, but also make the request to the api. With the error option, no api call is made.
             */
            validationState = warning.state;
            validationMessageKey = warning.messageKey;
            validationValues = warning.values ? warning.values : {};
        }
        const scene = this.context.scene ? "-" + this.context.scene : "";
        const inputClasses = classNames({
            input: true,
            overlayed: !!formatOverlay,
        });

        return (
            <div>
                <FormGroup className={groupClassName} controlId={scene + id} validationState={validationState}>
                    {label && (
                        <ControlLabel>
                            {label}
                            {required ? <span className="required"> *</span> : ""}
                        </ControlLabel>
                    )}
                    <div className="input-wrapper">
                        <div className={inputClasses} data-overlay={formatOverlay}>
                            <InputMask
                                {...input}
                                mask={mask}
                                placeholder={placeholder}
                                onChange={input.onChange}
                                onPaste={onPaste}
                                disabled={disabled}
                                onBlur={onBlur}
                            >
                                {(inputProps) => {
                                    return this.generateControl(inputProps);
                                }}
                            </InputMask>
                        </div>
                    </div>
                    {(error || (touched && warning) || showFieldValidationError) && (
                        <HelpBlock>
                            <FormattedMessage id={validationMessageKey} values={validationValues} />
                        </HelpBlock>
                    )}
                </FormGroup>
            </div>
        );
    }
}

MaskedInput.childContextTypes = {
    scene: PropTypes.string,
};

MaskedInput.propTypes = {
    disabled: PropTypes.bool,
    groupClassName: PropTypes.string,
    id: PropTypes.string.isRequired,
    input: PropTypes.object.isRequired,
    label: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    meta: PropTypes.object.isRequired,
    mask: PropTypes.string,
    placeholder: PropTypes.string,
    required: PropTypes.bool,
    validationMessageKey: PropTypes.object,
    valicaitonValues: PropTypes.object,
    rest: PropTypes.object,
    onChange: PropTypes.func,
    type: PropTypes.string,
    validation: PropTypes.object,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    className: PropTypes.string,
    formatOverlay: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.bool]),
    showValidationError: PropTypes.bool,
    showFieldValidationError: PropTypes.bool,
    onPaste: PropTypes.func,
    onBlur: PropTypes.func,
    forcedValidationErrorKey: PropTypes.string,
};

export default MaskedInput;



// WEBPACK FOOTER //
// ./src/components/common/form/MaskedInput.js